import { render, staticRenderFns } from "./AmendmentDocument.vue?vue&type=template&id=25598983"
import script from "./AmendmentDocument.vue?vue&type=script&lang=js"
export * from "./AmendmentDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports